export default "__VITE_ASSET__CStTSrb3__"